// use * as styled to import  everything so prettier will format createGlobalStyle
import * as styled from "styled-components";
export const GlobalStyle = styled.createGlobalStyle `
  :root {
    @font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,;
    @font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,;
    --opendash-header-row-height: 46px;
    --opendash-primary-color: #666767;

    --opendash-logocolor-darkgray: #666767;

    --opendash-color-white: #fff;
    --opendash-color-black: #000;
    --opendash-color-gray: gray;
    --opendash-color-lightblack: #303030;
    --opendash-color-lightgray: #fafafa;
    --opendash-color-darkgray: #999;
    --opendash-color-green: green;
    --opendash-color-red: red;
    --opendash-color-blue: #4186c6;
    --opendash-color-yellow: #d2d532;
    --opendash-color-slider-good: #1e8c00;
    --opendash-color-slider-middle: #ff9900;
    --opendash-color-slider-bad: #8c0000;

    --opendash-padding-10: 10px;
  }

  html,
  .ant-popover {
    white-space: pre-line;
  }

  .od-page-header {
    margin-bottom: 16px;
    padding: 24px;
    background: white;
  }

  .od-page-main {
    width: 100%;
    padding: 24px;
    background: white;
  }

  a,
  .ant-btn-link,
  .ant-typography a {
    color: var(--ant-primary-color);

    &:hover,
    &:not(:disabled):hover {
      color: var(--ant-primary-color-hover);
    }
  }

  .depth-1 {
    background-color: #fdfdfd;
  }

  .depth-0 {
    background-color: #f9f9f9;
  }

  @media only screen and (max-width: 620px) {
    :root {
      --opendash-padding-10: 0px;
    }

    .od-page-header {
      margin-bottom: 0px;
      padding: 15px;
      padding-bottom: 0px;
      background: white;
    }

    .od-page-main {
      width: 100%;
      padding: 15px;
      background: white;
    }
  }

  @media print {
    #opendash-header {
      position: relative;
    }

    #opendash-header > div > div > div:nth-child(2) {
      display: none;
    }
    #opendash-layout {
      padding-top: 0;
    }
    #opendash-footer {
      display: none;
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,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